import { styled } from '@mui/material/styles';
import { Drawer } from '@mui/material';

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  '.MuiDrawer-paper': {
    width: '380px',
    padding: theme.spacing(3),
    boxSizing: 'border-box',
  },
}));

export const Form = styled('form')(() => ({
  height: '100%',
}));
